import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { DiamondRateRepository } from "../repositories/diamondRateRepository";
import { DiamondRates, setDiamondRateState } from "../store/diamondRateSlice";
import { selectDiamondRates } from "../store/sessionSelectors";
import { showSuccess } from "../library/feedback";

export const useDiamondRateHook = () => {
    const dispatch = useDispatch();
    const diamondRatesState = useSelector(selectDiamondRates);

    useEffect(() => {
        DiamondRateRepository.getRates().then(diamondRates => {
            const ratesData = {} as any;
            diamondRates.forEach((data) => {
                const { id, ...rates } = data;
                ratesData[data.id] = { ...rates }
            });
            dispatch(setDiamondRateState(ratesData as DiamondRates))
        })
    }, [dispatch])

    type diamondTypeRateData = {
        '+2to6.5': number,
        '+6.5to8': number,
        '+8to9': number,
        '+9to10': number,
        '+10to11': number,
        '-2': number,
        '+11-12': number,
        '+12-14': number,
        '1/6(0.14-0.17)': number,
        '1/5(0.18-0.22)': number,
        '1/4(0.23-0.29)': number,
        '1/3(0.30-0.37)': number
    }

    function updateDiamondRate(diamondRate: diamondTypeRateData, diamondType: string) {
        DiamondRateRepository.addRate(diamondRate, diamondType).then(() => {
            showSuccess("Diamond rate added successfully.");
        })
    }

    return {
        diamondRatesState,
        updateDiamondRate
    }
}